import React, { Component } from "react";
import { Modal, Form, Row, Col, Button } from "antd";
import InputForm from "./InputForm";
import { checkFormIsValid } from '../utils/Validator';
import "./Form.css";

const { Item: ItemForm } = Form;

export const OPCOES_PAGADOR = [
  { key: 'CIF', label: 'CIF - FRETE EMPRESA' },
  { key: 'FOB', label: 'FOB - FRETE CLIENTE' },
  { key: 'AMB', label: 'AMBOS' },
]

export default class TabelaFreteForm extends Component {
  state = {
    registro: {
      tf_idf: '',
      tf_tipo: { key: 'CIF' },
      tf_vlr_ped_ini: 0,
      tf_vlr_ped_fim: 0,
      tf_perc_frete: 0,
      tf_vlr_frete: 0,
    },
    tf_tipo: { key: 'CIF', label: "" }
  };


  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado,
        tf_tipo: { key: this.props.registroSelecionado.tf_tipo.key, label: "" }
      }, () => {
        this.refs.tf_tipo.focus();
      });
    }
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
  };

  onChangePerc = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value,
      'tf_vlr_frete': 0
    });
  };

  onChangeVlr = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value,
      'tf_perc_frete': 0
    });
  };



  onOK = () => {
    if ((!this.state.registro.tf_tipo) || (this.state.registro.tf_tipo.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Tipo de Pagador' });
      return;
    }
    if (this.state.tf_perc_frete > 100) {
      Modal.warning({ title: 'Aviso!', content: 'Percentual de Frete acima de 100%' });
      return;
    }

    const reg = {
      tf_idf: this.state.registro.tf_idf,
      tf_tipo: this.state.registro.tf_tipo.key,
      tf_vlr_ped_ini: this.state.registro.tf_vlr_ped_ini,
      tf_vlr_ped_fim: this.state.registro.tf_vlr_ped_fim,
      tf_perc_frete: this.state.registro.tf_perc_frete,
      tf_vlr_frete: this.state.registro.tf_vlr_frete,
    }

    this.props.onSalvarClick(reg);
  };

  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { tf_idf, tf_tipo, tf_vlr_ped_ini, tf_vlr_ped_fim, tf_perc_frete, tf_vlr_frete } = this.state.registro;

    // console.log('TabelaFreteForm - state: ', this.state)

    return (
      <Modal
        title={tf_idf ? "Edição de Tabela de Frete" : "Cadastro de Tabela de Frete"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"40%"}
        style={{ top: 30 }}
      >
        <Form>
          <Row>
            <Col xs={24} sm={24} >
              <span>Tipo de Pagador</span>
              <InputForm
                type="select"
                id="tf_tipo"
                ref="tf_tipo"
                value={tf_tipo}
                placeholder="Selecione"
                onChange={this.onChange}
                data={OPCOES_PAGADOR}
                validator={value => Boolean(value)}
                style={{ width: "100%" }}
              />
            </Col>
            <Col xs={24} sm={12} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Valor Pedido Inicial</span>
              <InputForm
                type="number"
                id="tf_vlr_ped_ini"
                ref="tf_vlr_ped_ini"
                value={tf_vlr_ped_ini}
                onChange={this.onChange}
              />
            </Col><Col xs={24} sm={12} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Valor Pedido Final</span>
              <InputForm
                type="number"
                id="tf_vlr_ped_fim"
                ref="tf_vlr_ped_fim"
                value={tf_vlr_ped_fim}
                onChange={this.onChange}
              />
            </Col><Col xs={24} sm={12} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Percentual Frete</span>
              <InputForm
                type="number"
                id="tf_perc_frete"
                ref="tf_perc_frete"
                value={tf_perc_frete}
                onChange={this.onChangePerc}
                disabled={tf_vlr_frete}
              />
            </Col><Col xs={24} sm={12} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Valor Frete</span>
              <InputForm
                type="number"
                id="tf_vlr_frete"
                ref="tf_vlr_frete"
                value={tf_vlr_frete}
                onChange={this.onChangeVlr}
                disabled={tf_perc_frete}
              />
            </Col>
          </Row>
          <ItemForm>
            <Row>
              <Col xs={24}>
                 <Button
                  htmlType="button"
                  loading={carregando}
                  onClick={this.onOK}
                  className="botoesModalForm"
                >
                  Salvar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="botoesModalFecharForm"
                >
                  Cancelar
                </Button>
              </Col>
            </Row>
          </ItemForm>

        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TabelaFreteForm.js